module.exports = __webpack_public_path__ + "img/20220422123316322iz3.5d92b13b.jpg";